// Module
var code = `<h2 class="section-header">Atm batch acquirers upload history</h2>

<table ng-table="\$ctrl.tableConfig" class="table no-print">
  <thead>
  <tr>
    <th>No</th>
    <th>Network</th>
    <th>FileType</th>
    <th>File name</th>
    <th>Rows count</th>
    <th>Uploaded on</th>
    <th>Uploaded by</th>
    <th>Remarks</th>
    <th/>
  </tr>
  </thead>
  <tr ng-repeat="batchFile in \$data">
    <td>{{\$index + 1 + (\$ctrl.tableConfig.page() - 1) * \$ctrl.tableConfig.count()}}</td>
    <td>{{batchFile.atmBatchFile.network}}</td>
    <td>{{batchFile.atmBatchFile.fileType}}</td>
    <td>{{batchFile.file.fileName}}</td>
    <td>{{batchFile.rowCount}}</td>
    <td>{{batchFile.atmBatchFile.uploadedOn}}</td>
    <td>{{batchFile.uploadedBy}}</td>
    <td>{{batchFile.atmBatchFile.remarks}}</td>
    <td>
      <button ng-click="\$ctrl.showDetails(batchFile.atmBatchFile.id)" class="btn btn-primary">Details</button>
    </td>
  </tr>
</table>

<div ng-if="!\$ctrl.totalRowCount" class="empty-message">
  <span>ATM batch acquirers upload history is blank</span>
</div>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/atm/batch/atm-batch-acquirers-upload-history.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;